import * as React from "react"
import { cn } from "../../lib/utils"

const NumericInput = React.forwardRef(({ className, value, onChange, onFocus, ...props }, ref) => {
  const handleFocus = (e) => {
    // Select all text when focusing (makes it easy to replace)
    e.target.select();
    // If value is 0, clear it
    if (parseFloat(e.target.value) === 0) {
      onChange?.({ target: { value: '' } });
    }
    onFocus?.(e);
  };

  const handleBlur = (e) => {
    // If empty, restore to 0
    if (e.target.value === '' || e.target.value === null) {
      onChange?.({ target: { value: '0' } });
    }
  };

  return (
    <input
      type="number"
      className={cn(
        "flex h-10 w-full rounded-md border border-input bg-background px-3 py-2 text-sm ring-offset-background file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50",
        className
      )}
      ref={ref}
      value={value}
      onChange={onChange}
      onFocus={handleFocus}
      onBlur={handleBlur}
      {...props}
    />
  )
})
NumericInput.displayName = "NumericInput"

export { NumericInput }
